export const toRoman = (num) => {
    const romanMap = [
      ["M", 1000],
      ["CM", 900],
      ["D", 500],
      ["CD", 400],
      ["C", 100],
      ["XC", 90],
      ["L", 50],
      ["XL", 40],
      ["X", 10],
      ["IX", 9],
      ["V", 5],
      ["IV", 4],
      ["I", 1],
    ];
  
    return romanMap.reduce((acc, [roman, value]) => {
      while (num >= value) {
        acc += roman;
        num -= value;
      }
      return acc;
    }, "");
  };